import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast,
  VStack,
  RadioGroup,
  Radio,
  Stack,
  Text,
  Box,
} from "@chakra-ui/react";
import axios from "axios";
import { api_url } from "../../../url";

const AdjustWalletModal = ({ isOpen, onClose, user, onUpdate }) => {
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("credit"); // credit (add) or debit (redeem)
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      toast({
        title: "Invalid Amount",
        description: "Please enter a valid amount greater than 0.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${api_url}/transactions/transfer`,
        {
          userId: user._id,
          amount: Number(amount),
          type: type,
          description: description || `${type === 'credit' ? 'Credit' : 'Redeem'} by Admin`,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.transaction) {
        toast({
          title: "Success",
          description: `Wallet ${type === 'credit' ? 'credited' : 'debited'} successfully.`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        if (onUpdate) onUpdate();
        onClose();
        setAmount("");
        setDescription("");
      }
    } catch (error) {
      console.error("Adjustment Error:", error);
      toast({
        title: "Error",
        description: error.response?.data?.message || "Failed to adjust wallet.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
      <ModalContent borderRadius="xl" shadow="2xl">
        <ModalHeader borderBottom="1px solid" borderColor="gray.100">
          Adjust User Wallet
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody py={6}>
          <VStack spacing={6}>
            <FormControl>
              <FormLabel fontWeight="bold">Action Type</FormLabel>
              <RadioGroup onChange={setType} value={type}>
                <Stack direction="row" spacing={8}>
                  <Radio value="credit" colorScheme="green">
                    Add Credit (+)
                  </Radio>
                  <Radio value="debit" colorScheme="red">
                    Redeem Credit (-)
                  </Radio>
                </Stack>
              </RadioGroup>
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="bold">Amount (₹)</FormLabel>
              <Input
                placeholder="Enter amount"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                size="lg"
                focusBorderColor={type === "credit" ? "green.400" : "red.400"}
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold">Description / Remark</FormLabel>
              <Input
                placeholder="Optional: reason for adjustment"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </FormControl>

            <Box w="full" p={3} bg={type === "credit" ? "green.50" : "red.50"} borderRadius="md">
                <Text fontSize="sm" color={type === "credit" ? "green.600" : "red.600"} fontWeight="500">
                    This will {type === "credit" ? "add" : "deduct"} ₹{Number(amount || 0).toLocaleString()} {type === "credit" ? "to" : "from"} <b>{user?.username}</b>'s balance.
                </Text>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter borderTop="1px solid" borderColor="gray.100">
          <Button
            colorScheme={type === "credit" ? "green" : "red"}
            mr={3}
            onClick={handleSubmit}
            isLoading={loading}
            size="lg"
            w="full"
          >
            Confirm {type === "credit" ? "Add" : "Redeem"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AdjustWalletModal;
